/**
 * Videos Database can be added here.
 * You can add videos of your wish with different attributes
 * */

export const videos = [
  {
    _id: "6ecfzeL4KKg",
    title: "Death Note: Episode 1",
    videoUrl:"https://youtu.be/6ecfzeL4KKg",
    category:"Thriller"
  },
  {
    _id: "FMxaCRLuRlQ",
    title: "The Beginning: Netflix Trailer",
    videoUrl: "https://youtu.be/FMxaCRLuRlQ",
    category:"Thriller"
  },
  {
    _id:"bOoYggSG-oY",
    title: "Naruto: Season 1 Episode 1",
    videoUrl: "https://youtu.be/bOoYggSG-oY",
    category:"Action"
  },
  {
    _id: "9e8kR-dhaug",
    title: "Death Note: Episode 2",
    videoUrl: "https://youtu.be/9e8kR-dhaug",
    category:"Thriller"
  },
  {
    _id:"WCh5F0gd5mk",
    title: "Beyblade: Season 1, Episode 1",
    videoUrl: "https://youtu.be/WCh5F0gd5mk",
    category:"Adventure"
  },
  {
    _id:"p8uT9y4cPwY",
    title: "Demon Slayer - Rengoku vs Akaza",
    videoUrl: "https://youtu.be/p8uT9y4cPwY",
    category:"Action"
  },
  {
    _id:"ouCbRsP5N0I",
    title: "Naruto: Sasuke vs Itachi Uchiha",
    videoUrl: "https://youtu.be/ouCbRsP5N0I",
    category:"Action"
  },
  {
    _id:"xDbg3JWW_hw",
    title: "Naruto vs Pain",
    videoUrl: "https://youtu.be/xDbg3JWW_hw",
    category:"Action"
  },
  {
    _id:"UN66i-JWaWc",
    title: "Demon Slayer Trailer Season 1",
    videoUrl: "https://youtu.be/UN66i-JWaWc",
    category: "Action"
  },
  {
    _id: "_qNmE0xQgfI",
    title: "Dragon Ball Z",
    videoUrl:"https://youtu.be/_qNmE0xQgfI",
    category:"Action"
  },
  {
    _id: "YzuJnyebc40",
    title: "Psycho-Pass",
    videoUrl: "https://youtu.be/YzuJnyebc40",
    category: "Crime"
  },
  {
    _id: "zKKLZRutbiI",
    title: "Great Pretender",
    videoUrl: "https://youtu.be/zKKLZRutbiI",
    category: "Crime"
  }
];
